import React from 'react';

/*
 *Component for displaying IDs (chat id, company id) on different screens
 */
const DisplayKey = ({ displayKey }) => {
  return (
    <>
      <div className="displayKey text-right pb-1r">
        <span className="fw-600">ID: {displayKey}</span>
      </div>
    </>
  );
};
export default DisplayKey;
